/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { useTranslation } from 'react-i18next'
import { AnimateInView } from '@/components/animate-in-view'

export function HowItWorks() {
  const { t } = useTranslation()

  const steps = [
    {
      num: '1',
      title: t('Register Account'),
      desc: t('Free registration with 100,000 Token trial quota'),
    },
    {
      num: '2',
      title: t('Create API Key'),
      desc: t('Login to dashboard to generate API Key, set usage limits'),
    },
    {
      num: '3',
      title: t('Recharge Balance'),
      desc: t('Recharge as needed, automatic billing by Token usage'),
    },
    {
      num: '4',
      title: t('Integrate & Call'),
      desc: t('One line of code to change base_url, compatible with OpenAI SDK'),
    },
  ]

  return (
    <section className='relative z-10 px-6 py-12 md:py-16'>
      <div className='mx-auto max-w-6xl'>
        <AnimateInView className='mb-16 text-center'>
          <h2 className='text-2xl font-bold tracking-tight md:text-3xl'>
            {t('Four Steps to Get Started')}
          </h2>
          <p className='text-muted-foreground mt-3 text-sm'>
            {t('From registration to calling, just a few minutes')}
          </p>
        </AnimateInView>

        <div className='grid gap-6 md:grid-cols-4'>
          {steps.map((step, i) => (
            <AnimateInView
              key={step.num}
              delay={i * 120}
              animation='fade-up'
              className='border-border/40 bg-muted/20 rounded-xl border p-8 text-center'
            >
              <div className='mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-red-600 text-white text-lg font-bold'>
                {step.num}
              </div>
              <h3 className='mb-2 text-base font-semibold'>{step.title}</h3>
              <p className='text-muted-foreground text-sm leading-relaxed'>
                {step.desc}
              </p>
            </AnimateInView>
          ))}
        </div>
      </div>
    </section>
  )
}
